import React from 'react';

import ReferencePickerPlugin from '../../../../types/ReferencePickerPlugin';
import { useTranslation } from '../../i18n';
import { SubmittalsItem } from '../../types';

const RemoveReferenceModalTitle: ReferencePickerPlugin<SubmittalsItem>['CustomRemoveEntityModalTitle'] =
  () => {
    const { t } = useTranslation();

    return <span>{t('REMOVE_REFERENCE_CONFIRMATION_TITLE')}</span>;
  };

export default RemoveReferenceModalTitle;
